var __jsx = React.createElement;
import React, { useState, useEffect } from "react";
import dynamic from "next/dynamic";
import Head from "next/head";
import { useStore } from "@dp/state";
import { observer } from "mobx-react-lite";
import { PageLayout } from "../../util/constants";
var DeliveryAddressComp = dynamic(function () {
  return import("@dp/xcomp").then(function (mod) {
    return mod.DeliveryAddress;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@dp/xcomp")];
    }
  }
});
var DeliveryAddress = function DeliveryAddress() {
  var _store$delivery;
  var store = useStore();
  var brandCodeDesc = store === null || store === void 0 || (_store$delivery = store.delivery) === null || _store$delivery === void 0 || (_store$delivery = _store$delivery.deliveryModel) === null || _store$delivery === void 0 || (_store$delivery = _store$delivery.brandCodeInfo) === null || _store$delivery === void 0 ? void 0 : _store$delivery.conceptCodeDesc;
  var _useState = useState(""),
    title = _useState[0],
    setTitle = _useState[1];
  var _useState2 = useState(true),
    loading = _useState2[0],
    setLoading = _useState2[1];
  useEffect(function () {
    var _store$initComponent;
    store === null || store === void 0 || (_store$initComponent = store.initComponent("Delivery")) === null || _store$initComponent === void 0 || _store$initComponent.then(function () {
      setLoading(false);
    });
  }, []);
  useEffect(function () {
    var getPageTitle = function getPageTitle() {
      return brandCodeDesc ? "Choose Your Delivery Address | ".concat(brandCodeDesc) : "Choose Your Delivery Address";
    };
    setTitle(getPageTitle());
  }, [brandCodeDesc]);
  return __jsx(React.Fragment, null, __jsx(Head, null, __jsx("title", null, title)), __jsx(DeliveryAddressComp, {
    loading: loading
  }));
};
DeliveryAddress["layout"] = PageLayout.NB_LAYOUT;
DeliveryAddress.layoutProps = {
  hideLinks: true,
  isDeliveryPage: true
};
export default observer(DeliveryAddress);